import React, { useState, useEffect } from 'react';
import { Card, Table, Alert } from 'antd';
import api from '../utils/api';

const Schedule = () => {
  const [schedule, setSchedule] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSchedule();
  }, []);

  const fetchSchedule = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Use the new user schedule endpoint
      const scheduleResponse = await api.get('/api/my-schedule');
      setSchedule(scheduleResponse.data.working_hours);
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to fetch schedule');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Day',
      dataIndex: 'day',
      key: 'day',
    },
    {
      title: 'Working Hours',
      key: 'hours',
      render: (_, record) => (
        <span>
          {record.start && record.end
            ? `${record.start} - ${record.end}`
            : 'Not set'}
        </span>
      ),
    },
  ];

  const scheduleData = schedule ? [
    { day: 'Monday', ...schedule.monday },
    { day: 'Tuesday', ...schedule.tuesday },
    { day: 'Wednesday', ...schedule.wednesday },
    { day: 'Thursday', ...schedule.thursday },
    { day: 'Friday', ...schedule.friday },
    { day: 'Saturday', ...schedule.saturday },
    { day: 'Sunday', ...schedule.sunday },
  ] : [];

  return (
    <Card title="My Department Schedule" loading={loading}>
      {error ? (
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
        />
      ) : (
        <Table
          columns={columns}
          dataSource={scheduleData}
          rowKey="day"
          pagination={false}
        />
      )}
    </Card>
  );
};

export default Schedule; 